'use strict'

module.exports = function (ngModule) {
  ngModule
  .directive('pgHeader', ["$location", function ($location) {
    return {
      replace: true,
      restrict: 'E',
      link: function (scope, ele, attrs) {
        var currHost = $location.host()
        var currPath = $location.path()
        scope.header = {
          fromBC: false,
          logoLink: ''
        }

        if (currPath === '/store_auth' ||
            currPath === '/store_signup' ||
            currPath === '/update_profile') {
          scope.header.fromBC = true
          scope.header.logoLink = (currHost === 'account.positivegrid.com')
            ? 'https://bcom.positivegrid.com'
            : 'https://bcom-stage.positivegrid.com'
        } else {
          scope.header.logoLink = '/'
          scope.header.fromBC = false
        }
      },
      templateUrl: function (elem, attrs) {
        return attrs.templateUrl || 'template/partial/header.html'
      },
      controller: 'HeaderCtrl'
    }
  }])
  .directive('pgFooter', function () {
    return {
      replace: true,
      restrict: 'E',
      templateUrl: 'template/partial/footer.html'
    }
  })
  .directive('pgLogo', function () {
    return {
      replace: true,
      restrict: 'E',
      templateUrl: 'template/partial/logo.html',
      scope: {
        ltype: '@',
        lval: '@'
      }
    }
  })
  .directive('customOnChange', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var onChangeHandler = scope.$eval(attrs.customOnChange)
        element.bind('change', onChangeHandler)
      }
    }
  })
  .directive('autoFocus', ["$timeout", function ($timeout) {
    return {
      restrict: 'AC',
      link: function (scope, element, attrs) {
        $timeout(function () {
          element[0].focus()
        }, 0)
      }
    }
  }])
  .directive('spinnerBtn', ["$rootScope", "$timeout", function ($rootScope, $timeout) {
    return {
      restrict: 'AC',
      link: function (scope, element) {
        var isMe = false
        var ele = angular.element(element)
        var spinner = angular.element('<i class="fa fa-circle-o-notch fa-spin"></i>')
        element.on('click', function () {
          isMe = true
        })
        var loadListener = $rootScope.$on('cfpLoadingBar:loading', function () {
          if (isMe) {
            ele.append(spinner)
          }
        })
        var completeListener = $rootScope.$on('cfpLoadingBar:completed', function () {
          $('.fa.fa-circle-o-notch').remove()
          isMe = false
        })

        element.on('$destroy', function () {
          loadListener()
          completeListener()
        })
      }
    }
  }])
  .directive('redeemFormat', ["$rootScope", "$timeout", function ($rootScope, $timeout) {
    return {
      restrict: 'AC',
      require: 'ngModel',
      link: function (scope, element, attrs, modelCtrl) {
        element.on('keypress', _formatRedeem)
        element.on('paste', _formatPaste)
        var $target = angular.element(element)

        if (scope.redeem.keycode) {
          var v = scope.redeem.keycode
          if (v.length > 0) {
            var formatVal = v.split('').map(function (word, idx) {
              if ((idx + 1) % 4 === 0 && (idx + 1) < v.length) {
                return word + ' '
              } else {
                return word
              }
            }).join('')
            assignValue(formatVal)
          }
        };

        function assignValue (value, assignToInput) {
          var formatVal = value.toUpperCase()
          scope.redeem.keycode = formatVal
          if (assignToInput) {
            $target.val(formatVal)
          }
        }

        function _formatPaste (e) {
          $timeout(function () {
            var v = $target.val()
            if (v.length > 0) {
              var formatVal = v.split('').map(function (word, idx) {
                if ((idx + 1) % 4 === 0 && (idx + 1) < v.length) {
                  return word + ' '
                } else {
                  return word
                }
              }).join('')
              assignValue(formatVal)
            }
          }, 100)
        }

        function _formatRedeem (e) {
          var formatVal = ''
          var upperLength = 12
          var value = $target.val()
          var digit = String.fromCharCode(e.which)
          var curr = (value + digit).replace(/\s/g, '')

          // block whitespace
          if (e.keyCode == 32) {
            e.preventDefault()
            return
          }

          // limit max number of input value
          if (curr.length > upperLength) {
            e.preventDefault()
            return
          }

          var formatReg = /(?:^|\s)([A-Za-z0-9]{4})$/
          if (formatReg.test(value)) {
            e.preventDefault()
            formatVal = value + ' ' + digit
            assignValue(formatVal, true)
          } else if (formatReg.test(value + digit)) {
            e.preventDefault()
            if (curr.length === upperLength) {
              formatVal = value + digit
            } else {
              formatVal = value + digit + ' '
            }
            assignValue(formatVal, true)
          } else {
            modelCtrl.$parsers.push(function (inputVal) {
              if (angular.isUndefined(inputVal)) {
                return
              }
              var formatted = inputVal.toUpperCase()
              if (formatted !== inputVal) {
                modelCtrl.$setViewValue(inputVal.toUpperCase())
                modelCtrl.$render()
              }
              return formatted
            })
          }
        }
      }
    }
  }])
  .directive('autoFillSync', ["$timeout", function ($timeout) {
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, ngModel) {
        var origVal = elem.val()
        $timeout(function () {
          var newVal = elem.val()
          if(ngModel.$pristine && origVal !== newVal) {
            ngModel.$setViewValue(newVal)
          }
        }, 500)
      }
    }
  }])
}



//////////////////
// WEBPACK FOOTER
// ./js/directives/main.js
// module id = 54
// module chunks = 0